"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pathOr2 = _interopRequireDefault(require("ramda/src/pathOr"));
var _applySpec2 = _interopRequireDefault(require("ramda/src/applySpec"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = (0, _applySpec2["default"])({
  paymentDeadline: (0, _pathOr2["default"])('', ['subscriptions', 'payment_deadline']),
  emailCustomers: (0, _pathOr2["default"])('', ['subscriptions', 'email_customers']),
  chargeAttempts: (0, _pathOr2["default"])('', ['subscriptions', 'charge_attempts']),
  chargesIntervalInDays: (0, _pathOr2["default"])('', ['subscriptions', 'charges_interval_in_days']),
  cancelAfterFailedCharges: (0, _pathOr2["default"])('', ['subscriptions', 'cancel_after_failed_charges']),
  useProportionalAmountOnDowngrade: (0, _pathOr2["default"])('', ['subscriptions', 'use_proportional_amount_on_downgrade'])
});
module.exports = exports["default"];